import axios from "axios";

export async function GetMethod(props, res, error) {
    try {
        const response = await axios.get(process.env.REACT_APP_SERVER + props.url, {
            headers: {
                Authorization: `ArNew ${props.token}`,
                lan: props?.lan

            },
        });

        if (response.status === 200 && response.data.status === "success") {
            return response?.data
        }

        return response?.data
    } catch (err) {
        if (err.response) {
            return err.response.data.msg;
        }
    }
}

export async function PostMethod(props, res, error) {
    axios({
        method: "POST",
        url: process.env.REACT_APP_SERVER + props.url,
        headers: {
            Authorization: `ArNew ${props.token}`,
        },
        data: props.body,
    })
        .then(function (response) {
            if (response.status === 200 && response.data.status === "success") {
                res(response.data);
            }
            return;
        })
        .catch(function (err) {

            if (err.response) {
                //یزره اذیت کرد گذاشتیم اینو
                error(err.response.data.msg);
            }
            return;
        });
}

export async function PatchMethod(props, res, error) {
    axios({
        method: "patch",
        url: process.env.REACT_APP_SERVER + props.url,
        headers: {
            Authorization: `ArNew ${props.token}`,
        },
        data: props.body,
    })
        .then(function (response) {
            if (response.status === 200 && response.data.status === "success") {
                res(response.data);
            }
            return;
        })
        .catch(function (err) {
            if (err.response) {
                //یزره اذیت کرد گذاشتیم اینو
                error(err);
            }
            return;
        });
}

export async function PutMethod(props, res, error) {
    axios({
        method: "PUT",
        url: process.env.REACT_APP_SERVER + props.url,

        headers: {
            Authorization: `ArNew ${props.token}`,
        },
        data: props.body,
    })
        .then(function (response) {
            if (response.status === 200 && response.data.status === "success") {
                res(response.data);
            }
            return;
        })
        .catch(function (err) {
            if (err.response) {
                //یزره اذیت کرد گذاشتیم اینو
                error(err);
            }
            return;
        });
}

export async function DeleteMethod(props, res, error) {
    axios({
        method: "DELETE",
        url: process.env.REACT_APP_SERVER + props.url,
        headers: {
            Authorization: `ArNew ${props.token}`,
        },
        data: props.body,
    })
        .then(function (response) {
            if (response.status === 200 && response.data.status === "success") {
                res(response.data);
            }
            return;
        })
        .catch(function (err) {
            error(err);
            return;
        });
}

//////// درخواست های غیر مجاز باید رفع شود
